// types
import {SaleCustomerActionTypes, SaleCustomerState, CustomerType} from "./types";

export const NewSaleCustomerItem:CustomerType = {
  enabled: true,
  name: '',
  order: 500
}

export const INIT_STATE_SALE_CUSTOMER: SaleCustomerState = {
  items: [],
  rightModalShow: false,
  removeModalShow: false,
  selectedItem: NewSaleCustomerItem,
  modalEditTitle: '',
  isSending: false,
  isFetched: false,
  isLoading: false,
  isNeedReload: false
};

const SaleCustomer = (state = INIT_STATE_SALE_CUSTOMER, action: any) => {
  switch (action.type) {
    case SaleCustomerActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case SaleCustomerActionTypes.GET_SALE_CUSTOMERS:
          return {
            ...state,
            items: action.payload.data.items,
            meta: action.payload.data.meta,
            isFetched: true,
            isLoading: false,
            isNeedReload: false
          };
        case SaleCustomerActionTypes.UPDATE_SALE_CUSTOMER:
          return {
            ...state,
            selectedItem: NewSaleCustomerItem,
            rightModalShow: false,
            isSending: false,
            isNeedReload: true
          };
        case SaleCustomerActionTypes.REMOVE_SALE_CUSTOMER:
          return {
            ...state,
            selectedItem: NewSaleCustomerItem,
            removeModalShow: false,
            isNeedReload: true
          };
        default:
          return { ...state };
      }

    case SaleCustomerActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case SaleCustomerActionTypes.GET_SALE_CUSTOMERS:
          return {
            ...state,
            isFetched: false,
            isLoading: false,
            isNeedReload: false
          };
        case SaleCustomerActionTypes.UPDATE_SALE_CUSTOMER:
          return {
            ...state,
            isSending: false
          };
        case SaleCustomerActionTypes.REMOVE_SALE_CUSTOMER:
          return {
            ...state,
            removeModalShow: false
          };
        default:
          return { ...state };
      }
    case SaleCustomerActionTypes.EDIT_SALE_CUSTOMER:
      return {
        ...state,
        selectedItem: action.payload.data,
        modalEditTitle: action.payload.modalEditTitle,
        rightModalShow: true
      }
    case SaleCustomerActionTypes.RIGHT_MODAL_SHOW:
      return {
        ...state,
        selectedItem: NewSaleCustomerItem,
        modalEditTitle: action.payload.modalEditTitle,
        rightModalShow: true
      }
    case SaleCustomerActionTypes.REMOVE_SALE_CUSTOMER_MODAL_SHOW:
      return {
        ...state,
        selectedItem: action.payload.data,
        modalEditTitle: action.payload.modalEditTitle,
        removeModalShow: true
      }
    case SaleCustomerActionTypes.REMOVE_SALE_CUSTOMER_MODAL_HIDE:
      return {
        ...state,
        selectedItem: NewSaleCustomerItem,
        removeModalShow: false
      }
    case SaleCustomerActionTypes.RIGHT_MODAL_HIDE:
      return {
        ...state,
        rightModalShow: false
      }
    case SaleCustomerActionTypes.UPDATE_SALE_CUSTOMER:
      return {
        ...state,
        isSending: true
      };
    case SaleCustomerActionTypes.GET_SALE_CUSTOMERS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return { ...state };
  }
};

export default SaleCustomer;
